// frontend/src/screens/cart/CartScreenEntry.js

import React, { useEffect, useState } from "react";
import CartScreen from "../cart/CartScreen";
import CartMobileScreen from "../cart/CartMobileScreen";
/**
 * CartScreenEntry
 * Renders desktop CartScreen OR CartMobileScreen
 * based on viewport width.
 *
 * Usage:
 *   <CartScreenEntry />
 */
export default function CartScreenEntry({ breakpoint = 991.98 }) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;

    const mediaQuery = window.matchMedia(`(max-width: ${breakpoint}px)`);

    const handleChange = (event) => {
      setIsMobile(event.matches);
    };

    setIsMobile(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener("change", handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener("change", handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, [breakpoint]);

  if (isMobile) {
    return <CartMobileScreen />;
  }

  return <CartScreen />;
}